import { faKey, faUserAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/base/Button';
import Section from 'components/base/Section';
import MemberAddressCard from 'components/cards/MemberContactCard';
import MemberProfileCard from 'components/cards/MemberProfileCard';
//import PageBreadcrumb from 'components/common/PageBreadcrumb';
//import ProfileDetailsTab from 'components/modules/e-commerce/profile/ProfileDetailsTab';
//import { defaultBreadcrumbItems } from 'data/commonData';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import memberService from 'services/member';
import { Member } from '../../../../data/members';
import { Link, useParams } from 'react-router-dom';
import SettingsPersonalInfo from 'components/forms/SettingsPersonalInfo';

const Profile = () => {
  const [memberData, setMemberData] = useState<Member | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const { userId } = useParams();

  useEffect(() => {
    setIsLoading(true);
    if (userId) {
      memberService
        .getMemberByID(userId)
        .then(data => {
          setMemberData(data);
          setIsLoading(false);
        })
        .catch(error => {
          console.error('Error:', error);
          setIsLoading(false);
        });
    } else {
      setIsLoading(false);
    }
  }, [userId]);
  if (isLoading) {
    return <div>Loading...</div>;
  }
  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
        <Row className="align-items-center justify-content-between g-3 mb-4">
          <Col xs="auto">
            <h2 className="mb-0">
              <FontAwesomeIcon className="me-2" icon={faUserAlt} />
              NuPitch Member Profile
            </h2>
          </Col>
          <Col xs="auto" className="d-flex flex-wrap gap-2 gap-sm-3">
            {/* <Button
              variant="phoenix-danger"
              startIcon={<FontAwesomeIcon className="me-2" icon={faTrashAlt} />}
            >
              Delete member
            </Button> */}
            <Link
              to={`/pages/authentication/split/forgot-password`}
              className="fs-9 fw-semi-bold"
            >
              <Button
                variant="phoenix-secondary"
                startIcon={<FontAwesomeIcon className="me-2" icon={faKey} />}
              >
                Reset password
              </Button>
            </Link>
          </Col>
        </Row>
        <Row className="g-3 mb-6">
          <Col xs={12} lg={8}>
            <MemberProfileCard memberData={memberData} />
          </Col>
          <Col xs={12} lg={4}>
            <MemberAddressCard memberData={memberData} />
          </Col>
        </Row>
        <SettingsPersonalInfo />
      </Section>
    </div>
  );
};

export default Profile;
